import { useAccountData } from "../firebase";
import { carbonUnitTypes } from "../otherHelpers";

const useDisplayMeasurementSystem = () => {
  const [{ displayMeasurementSystem, measurementSystem }] = useAccountData();
  const activeSystem = displayMeasurementSystem || measurementSystem;

  const carbonUnit =
    activeSystem === "pounds"
      ? "lbs"
      : activeSystem === "tons"
        ? "tons"
        : "kgs";
  const { converter, name } = carbonUnitTypes.find(
    ({ short }) => short === carbonUnit
  );

  return {
    measurementSystem: activeSystem,
    carbonUnit,
    carbonUnitLabel: name,
    convertCarbonUnits: converter
  };
};

export default useDisplayMeasurementSystem;
